
import {
    defineComponent,
    PropType,
    computed,
    onMounted,
    ref,
    getCurrentInstance
} from 'vue'
import BaseInputOutlined from '../../../inputs/BaseInputOutlined.vue'
import CustomActivatorSelect from '../../../inputs/CustomActivatorSelect.vue'
import TimeInput from '../../../inputs/TimeInput.vue'
import { EditedActivation } from '../../../../types/GCB2'
import { timezones } from '@/vars/timezones'
import { checkInputIsIntNumber } from '../../../../utils'
import DatePicker from '../../../ui/DatePicker.vue'
import cloneDeep from 'lodash/cloneDeep'
export default defineComponent({
    name: 'TimeLimitsSettings',
    components: { BaseInputOutlined, CustomActivatorSelect, TimeInput, DatePicker },
    props: {
        value: { type: Object as PropType<EditedActivation>, required: true },
        automailValidate: {
            type: Object,
            required: false,
        },
        massEdit: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    setup(props, { emit }) {
        const root = getCurrentInstance()!.proxy
        const currentTimezoneOffsetInHours = computed(() => {
            const currentDate = new Date()
            const timezoneOffsetMinutes = currentDate.getTimezoneOffset()
            const timezoneOffsetHours = (timezoneOffsetMinutes / 60) * -1
            return timezoneOffsetHours
        })
        const timeInit = ref(null)
        const timezonesList = timezones.map(el => ({
            id: parseInt(el.offset.replace(/[^0-9]/g, '')),
            name: el.cities.length ? `${el.timezone} (${el.cities.slice(0, 3).join(', ')})` : el.timezone,
            recomended: currentTimezoneOffsetInHours.value === Number(el.offset),
        }))

        const formInput = (e: any) => {
            emit('validation-updated', e)
        }
        const clear = () => {
            (root.$refs as any).form.resetValidation()
            props.value.extra.automail.sendAfter = timeInit.value.sendAfter
            props.value.extra.automail.sendBefore = timeInit.value.sendBefore
            props.value.extra.automail.timezoneOffset = timeInit.value.timezoneOffset
        }
        const toMinutes = (timeStr: string): number | null => {
            if (!timeStr || typeof timeStr !== 'string') return null
            const [hoursStr, minutesStr] = timeStr.split(':')
            const hours = Number(hoursStr)
            const minutes = Number(minutesStr)
            if (Number.isNaN(hours) || Number.isNaN(minutes)) return null
            return hours * 60 + minutes
        }

        const showWarning = computed(() => {
            const after = toMinutes(props.value.extra.automail.sendAfter)
            const before = toMinutes(props.value.extra.automail.sendBefore)
            if (after === null || before === null) return false
            return before <= after
        })
        const setDefaultTime = () => {
            if (!props.value.extra.automail.sendAfter) {
                props.value.extra.automail.sendAfter = '08:00'
            }
            if (!props.value.extra.automail.sendBefore) {
                props.value.extra.automail.sendBefore = '21:00'
            }
            if (!props.value.extra.automail.timezoneOffset && props.value.extra.automail.timezoneOffset !== 0) {
                props.value.extra.automail.timezoneOffset = currentTimezoneOffsetInHours.value
            }
        }

        onMounted(() => {
            setDefaultTime()
            timeInit.value = cloneDeep(props.value.extra.automail)
        })
        return {
            formInput,
            timezonesList,
            checkInputIsIntNumber,
            clear,
            showWarning
        }
    },
})
